// Mock Data Generator API client (admin). analyze → infer per-column generators
// + the FK cascade plan; preview → a few rows (no writes); run → streamed insert
// (background job token) or generated SQL.
import { api } from './api.js';

export const analyzeMockData = (body) => api.post('/api/tools/mock-data/analyze', body);
export const previewMockData = (body) => api.post('/api/tools/mock-data/preview', body);
export const runMockData = (body) => api.post('/api/tools/mock-data/run', body);
